import { ModelInside } from "api"
import ModelTextSection from "components/carModelPage/reusable/ModelTextSection"
import VideoModelFullScreen from "components/carModelPage/reusable/VideoModelFullScreen"
import styled from "styled-components"
import ImageViewerPanorama from "./ImageViewerPanorama/ImageViewerPanorama"
import InsideHighLights from "./InsideHighLights"
import Quizzes from "./Quiz/Quizzes"

const StyledPageDiv = styled.div`
  background-color: ${(p) => p.theme.colors.black};
  width: 100vw;
  min-height: max-content;
  height: max-content;
`
const StyledVideoWrapper = styled.div`
  ${(p) => p.theme.breakpoints.up("md")} {
    padding-right: 0px;
    padding-left: 0px;
  }
`

type InteriorSectionProps = {
  insideData: ModelInside
}

const InteriorSection = ({ insideData }: InteriorSectionProps) => {
  return (
    <StyledPageDiv>
      {insideData?.highLights && (
        <InsideHighLights data={insideData?.highLights} />
      )}
      {insideData?.frameText && (
        <ModelTextSection text={insideData.frameText} />
      )}
      {insideData?.video && (
        <StyledVideoWrapper>
          <VideoModelFullScreen
            src={insideData?.video?.desktopImageUrl}
            imgDesktop={insideData?.video?.desktopImageUrl}
            imgMobile={insideData?.video?.mobileImageUrl}
            alt={insideData?.video?.alt}
          />
        </StyledVideoWrapper>
      )}
      {insideData?.quiz && !!insideData?.quiz?.quizItems?.length && (
        <Quizzes data={insideData?.quiz} />
      )}
      {insideData?.panorama && (
        <ImageViewerPanorama data={insideData?.panorama} />
      )}
    </StyledPageDiv>
  )
}

export default InteriorSection
